module.exports = __webpack_public_path__ + "b29fd135b9474db9e962e053cd37e7d4.png";